(() => {
  const thumbnailSelector = '[data-drm-product-gallery-thumbnail]';
  const gallerySelector = '[data-drm-product-gallery]';
  const primaryImageSelector = '.drm-product-detail__visual-primary img';

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest(thumbnailSelector);
    if (!thumbnail) return;

    const gallery = thumbnail.closest(gallerySelector);
    const primaryImage = gallery?.querySelector(primaryImageSelector);
    if (!primaryImage) return;

    event.preventDefault();

    if (thumbnail.dataset.mainSrc) {
      primaryImage.src = thumbnail.dataset.mainSrc;
    }

    if (thumbnail.dataset.mainSrcset) {
      primaryImage.srcset = thumbnail.dataset.mainSrcset;
    }

    if (thumbnail.dataset.mainAlt !== undefined) {
      primaryImage.alt = thumbnail.dataset.mainAlt;
    }

    gallery.querySelectorAll(thumbnailSelector).forEach((button) => {
      button.removeAttribute('aria-current');
    });
    thumbnail.setAttribute('aria-current', 'true');
  });
})();
